import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, Download } from "lucide-react";
import { toast } from "sonner";

// Fetch a CSV through the authed client (plain <a href> would drop the JWT),
// then hand it to the browser as a download.
export async function downloadCsv(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  } catch { toast.error("Download failed"); }
}

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/customers").then((r) => setList(r.data)); }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return list;
    return list.filter((c) =>
      (c.name || "").toLowerCase().includes(s) ||
      (c.email || "").toLowerCase().includes(s) ||
      (c.phone || "").includes(s)
    );
  }, [list, q]);

  return (
    <div>
      <header className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest text-gray-400">CRM</div>
          <h1 className="font-display text-2xl font-bold tracking-tight mt-1">Customers</h1>
        </div>
        <button data-testid="customers-export" onClick={() => downloadCsv("/admin/export/customers.csv", "customers.csv")}
          className="inline-flex items-center gap-2 text-sm font-semibold px-4 h-10 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
          <Download className="w-4 h-4" aria-hidden /> Export CSV
        </button>
      </header>

      <div className="relative mb-4 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" aria-hidden />
        <Input data-testid="customers-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search name, email or phone…" className="pl-9 h-10 rounded-lg bg-white" />
      </div>

      <div className="qd-admin-card overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-gray-50 text-xs uppercase tracking-widest text-gray-500">
            <tr><th className="text-left p-3">Name</th><th className="text-left p-3">Email</th><th className="text-left p-3">Phone</th><th className="text-left p-3">Orders</th><th className="text-left p-3">Spend</th><th className="text-left p-3">Loyalty Pts</th></tr>
          </thead>
          <tbody>
            {filtered.map((c) => (
              <tr key={c.id} data-testid={`cust-row-${c.id}`} className="border-t border-gray-100">
                <td className="p-3 font-medium">{c.name}</td>
                <td className="p-3 text-gray-600">{c.email}</td>
                <td className="p-3 text-gray-600">{c.phone || "—"}</td>
                <td className="p-3">{c.order_count}</td>
                <td className="p-3">₹{c.lifetime_spend}</td>
                <td className="p-3">{c.wallet.balance}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-gray-400">{q ? `No customers match “${q}”` : "No customers yet"}</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
